import { languageMap } from ".."

languageMap.elm = {
	comments: {
		line: "--",
		block: ["{-", "-}"],
	},
}
